import { QueryClient } from "@tanstack/react-query";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function participantSurveysViewLoader(queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  queryClient.prefetchQuery(
    USERS_QUERIES.surveys(user.id.toString(), {
      params: {
        limit: 50,
        skip: 0,
        type: "interview_round",
      },
    }),
  );

  return null;
}
